import { fetchJSON } from "../framework/api";
import * as Dialog from "../framework/dialog";
import { getUITranslation } from "../utils/get_ui_translation";

$(document).on("click", ".send-payment-link-btn", onSendPaymentLink).on("click", ".js-get-payment-link-btn", onGetPaymentLink);

async function onGetPaymentLink(event) {
  const target = event.target.closest("button");
  const id = target.dataset.id;
  const getPaymentLinkSpinner = target.querySelector(".js-get-payment-link-btn-spinner");

  getPaymentLinkSpinner.classList.remove("has-hidden");

  try {
    const body = await fetchJSON(p`/ajax/invoices/${id}/payment_link`);
    if (body.success) {
      window.open(body.link, "_blank");
    } else {
      Dialog.alert(getUITranslation("LINK_UNAVAILABLE"), body.error);
    }
  } catch {
    Dialog.alert(getUITranslation("LINK_UNAVAILABLE"), getUITranslation("ERR_LINK_OCCURED_CONTACT_US"));
  } finally {
    getPaymentLinkSpinner.classList.add("has-hidden");
  }
}

async function onSendPaymentLink(event) {
  const target = event.target.closest("button");
  const sendPaymentLinkSpinner = target.querySelector(".js-send-payment-link-btn-spinner");
  const id = target.dataset.id;
  const noemail = target.dataset.noemail;

  if (noemail != undefined) {
    return Dialog.alert(getUITranslation("EMAIL_CANT_BE_SEND"), getUITranslation("ERR_NO_EMAIL"));
  }

  sendPaymentLinkSpinner.classList.remove("has-hidden");

  try {
    const body = await fetchJSON(p`/ajax/invoices/${id}/send_payment_link`, {
      method: "POST",
    });
    if (body.success) {
      Dialog.alert(getUITranslation("EMAIL_SEND"), getUITranslation("EMAIL_IN_HISTORY"));
    } else {
      Dialog.alert(getUITranslation("EMAIL_NOT_SEND"), body.error);
    }
  } catch {
    Dialog.alert(getUITranslation("EMAIL_NOT_SEND"), getUITranslation("ERR_OCCURED_CONTACT_US"));
  } finally {
    sendPaymentLinkSpinner.classList.add("has-hidden");
  }
}
